import { FieldType } from 'types/graphql'

export const SCHEDULED_HEADERS = ['Repeats', 'Start Of Next Period', 'Status']

export const SORTABLE_FIELDS = [
  FieldType.Text,
  FieldType.Number,
  FieldType.Date,
  FieldType.Switch,
  FieldType.Tag,
  FieldType.PickList,
  FieldType.Lookup
]
